export function ValuesIcon({ className, color = 'black' }) {
  return (
    <svg className={className} width="37" height="35" viewBox="0 0 37 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.3889 29.1471H36M1 29.1471H4.88889M4.88889 29.1471C4.88889 31.8273 7.06528 34 9.75 34C12.4347 34 14.6111 31.8273 14.6111 29.1471C14.6111 26.4669 12.4347 24.2941 9.75 24.2941C7.06528 24.2941 4.88889 26.4669 4.88889 29.1471ZM34.0556 17.5H36M1 17.5H14.6111M20.4444 5.85294H36M20.4444 5.85294C20.4444 3.17274 18.2681 1 15.5833 1C12.8986 1 10.7222 3.17274 10.7222 5.85294C10.7222 8.53315 12.8986 10.7059 15.5833 10.7059C18.2681 10.7059 20.4444 8.53315 20.4444 5.85294ZM1 5.85294H2.94444M27.25 22.3529C24.5653 22.3529 22.3889 20.1802 22.3889 17.5C22.3889 14.8198 24.5653 12.6471 27.25 12.6471C29.9347 12.6471 32.1111 14.8198 32.1111 17.5C32.1111 20.1802 29.9347 22.3529 27.25 22.3529Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
